export const EMAIL_TEMPLATES_QUERY_KEY = 'emailTemplates';
export const EMPLOYEE_NOTICE_QUERY_KEY = 'employee-notice';
export const EMPLOYEE_EQUIPMENT_QUERY_KEY = 'employee-equipment';
export const EQUIPMENT_SETTINGS_QUERY_KEY = 'equipment-settings';

// Events an email template can be written for (server: emailTemplates.events.js).
export const EMAIL_TEMPLATE_EVENTS = [
  'newEmployee',
  'employeeLeaving',
  'birthday',
  'workAnniversary',
  'promotion',
  'general',
];
